import React from 'react';
import './App.css';
import SwaggerUI from "swagger-ui-react"
import {
    BrowserRouter as Router,
    Route,
    // Link,
    Routes,
    Link
} from "react-router-dom";
import * as contentApiSpec from './swagger-json/content-api.json';
import * as answersApiSpec from './swagger-json/answers-api.json';

function App() {
  return (
    <Router>
        <div>
            <nav className="top-nav">
                <div className="top-nav-logo-area">
                    <a href="https://www.cludo.com/cludo-developer-experience" title="Cludo Developer Experience">
                        <img alt="top nav logo" className="top-nav__img" src="./assets/cludoapilogo.png" />
                    </a>
                    <ul className="top-nav-links">
                        {/* <li>
                            <Link to="/">Home</Link>
                        </li>
                        <li>
                            <Link to="/search-api">Search APIs</Link>
                        </li> */}
                        <li className="top-nav-link">
                            <Link to="/content-api">Content APIs</Link>
                        </li>
                        <li className="top-nav-link">
                            <Link to="/qa-api">Q&A APIs</Link>
                        </li>
                        {/* <li>
                            <Link to="/event-tracking-api">Event Tracking APIs</Link>
                        </li>
                        <li>
                            <Link to="/analytics-api">Analytics APIs</Link>
                        </li> */}
                    </ul>
                </div>
                <a href='https://docs.cludo.com' className="top-nav-v3-link" target='_blank' rel="noreferrer">
                    V3 (legacy) API documentation &#8594;
                </a>
            </nav>

            <Routes>
                <Route path="/" Component={() => {
                    window.location.href = 'https://www.cludo.com/cludo-developer-experience';
                    return null;
                }}/>
                <Route path="/search-api" element={<>Hello world</>} />
                <Route path="/content-api" element={<SwaggerUI spec={contentApiSpec} />} />
                <Route path="/analytics-api" element={<>Hello world</>} />
                <Route path="/qa-api" element={<SwaggerUI spec={answersApiSpec} />} />
                <Route path="/event-tracking-api" element={<>Hello world</>} />
            </Routes>
        </div>
    </Router>
  );
}

export default App;
